var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBasketball(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M19.57 3.92a23.09 23.09 0 0 0-7 3.39.53.53 0 0 0 .47.94 25.93 25.93 0 0 1 7.11-3.77c.53-.19.04-.74-.58-.56Z",
    fill: "#8841B9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23 10.89c.3-.06.14-.67-.32-.73a13.2 13.2 0 0 0-7.18.84c-.47.39-.32.83.37.86l.08 0a14.11 14.11 0 0 1 7.05-.97Z",
    fill: "#8841B9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.45 16.4a10.84 10.84 0 0 1 2.38-2.73 11 11 0 0 1 1.31-1.05c.27-.28-.21-1.06-.83-.71a9.42 9.42 0 0 0-1.22.88 11 11 0 0 0-2.54 3.09 13.05 13.05 0 0 0-1.22 3.39 14.53 14.53 0 0 0-.25 2c-.05.66.43.79.57.53a18.39 18.39 0 0 1 .47-2.3 12.4 12.4 0 0 1 1.33-3.1Z",
    fill: "#8841B9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.45 14.31a33.28 33.28 0 0 1 2.4-2.54 26.66 26.66 0 0 1 2.3-2c.65-.59-.27-1-.75-.73a20.49 20.49 0 0 0-2.35 2 28.23 28.23 0 0 0-2.35 2.67 14.77 14.77 0 0 0-1.26 2.08c-.36.71-.68 1.44-1 2.16-.13.43.21.85.46.55.41-.77.81-1.56 1.26-2.32a12 12 0 0 1 1.29-1.87Z",
    fill: "#8841B9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.89 3.5A12 12 0 0 0 14 .08a12.12 12.12 0 0 0-2.77 0A13.7 13.7 0 0 0 8.5.61a12.43 12.43 0 0 0-6.89 5.9 12.18 12.18 0 0 0-1.07 9 10.4 10.4 0 0 0 3.77 5.39 16.39 16.39 0 0 0 5.89 2.78C21.34 26.31 28.13 11 20.89 3.5ZM10.44 22.72A15.83 15.83 0 0 1 5 20.06a9.15 9.15 0 0 1-3.35-4.82 11.06 11.06 0 0 1-.09-5.39 11.52 11.52 0 0 1 1-2.8 11.71 11.71 0 0 1 1.57-2.21c.87.31 1.77.52 2.64.83.08 0 2.33.52 6.44 5.33 3.77 4.17 4.11 4.85 4.29 5.11A16.82 16.82 0 0 1 19.55 20l0 .05a9.41 9.41 0 0 1-9.11 2.67Zm9.65-3.26a17.22 17.22 0 0 0-1.84-3.84c-.8-1.27-3.93-5.08-4.17-5.37C13.2 9.26 11.2 6 7 4.9c-.8-.21-1.61-.37-2.42-.58a11 11 0 0 1 4.25-2.75 13.8 13.8 0 0 1 5-.6 11.9 11.9 0 0 1 3.39.94 9.91 9.91 0 0 1 5.29 5.43c1.57 4-.17 8.25-.21 8.37a12.88 12.88 0 0 1-2.21 3.75Z",
    fill: "#B557F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.85 1.35c-.47-.68-.63-.09-.78 1.61a8.31 8.31 0 0 1-1.23 2.62c-.18.48.36.77.85.38a8.92 8.92 0 0 0 1.17-2.82 3.39 3.39 0 0 0-.01-1.79Z",
    fill: "#8841B9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.37 7.66c.24-.49-.63-.92-1-.43a26.38 26.38 0 0 1-2.57 2.2 18 18 0 0 1-4.16 2.15c-.32.23-.3.59 0 .73a16.55 16.55 0 0 0 4.77-2 14.6 14.6 0 0 0 2.96-2.65Z",
    fill: "#8841B9"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBasketball);
export default __webpack_public_path__ + "static/media/basketball.7e4eb2ff37e455131a559f1b4ec60a1d.svg";
export { ForwardRef as ReactComponent };